
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/games/treasure-trail/login",
      function () {
        return require("private-next-pages/games/treasure-trail/login.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/games/treasure-trail/login"])
      });
    }
  